import { string } from "yup";
export var GiftCardText;
(function (GiftCardText) {
    GiftCardText["TITLE"] = "Gift Cards";
    GiftCardText["ADD_A_CARD"] = "Add a card";
    GiftCardText["USE_CARD_BALANCE"] = "Use card balances";
    GiftCardText["BALANCE"] = "Balance:";
    GiftCardText["APPLY_TO_ORDER"] = "Apply to order";
    GiftCardText["ADD"] = "Add";
    GiftCardText["APPLY_GIFT_CARD"] = "Apply gift card";
    GiftCardText["CONFIRM"] = "Confirm";
    GiftCardText["GIFT_CARD_NUMBER_REQUIRED_MESSAGE"] = "Please enter a gift card number";
    GiftCardText["EXISTING_GIFT_CARD_REQUIRED_MESSAGE"] = "Please select a gift card";
    GiftCardText["GIFT_CARD_NUMBER"] = "Gift card number";
    GiftCardText["GIFT_CARD_NOT_FOUND"] = "Gift card not found!";
})(GiftCardText || (GiftCardText = {}));
export const addGiftCardFormSchema = {
    giftCardNumber: string().required(GiftCardText.GIFT_CARD_NUMBER_REQUIRED_MESSAGE),
};
export const existingGiftCardFormSchema = {
    giftCardNumber: string().required(GiftCardText.EXISTING_GIFT_CARD_REQUIRED_MESSAGE),
};
